__turbopack_context__.v({
  "genres": "MHUiaa_genres",
  "navigation": "MHUiaa_navigation",
  "tabs": "MHUiaa_tabs",
  "team": "MHUiaa_team",
  "teams": "MHUiaa_teams",
});
